module.exports = __webpack_public_path__ + "static/media/2.6bb47235.jpg";